import {ACTIONS, INITIAL_STATE,START_OVER_STATE, DEFAULT_STATE_VALUE,CHARM_9000} from '../constants.js'
import ReactGA from 'react-ga';
import {filter,get_sku} from './utils'
import smoothscroll from 'smoothscroll-polyfill';
window.__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();
function refreshAccOption(state2,thisVal,in1){
  var newclist
  let h2all=[]
  var h2list=CHARM_9000
  
if (state2['style']==='9082')
h2list={
  "1":['9030','9032','9042','9187','9038','9031','9186','9035','9036','9033','9037','9039','9034','9041','9028','9029','9040'],
  "2":['9043','9045','9044'],
  "3":['9046','9047','9048','9049','9050','9051','9052','9053','9054','9055','9056','9057','9058','9059','9060','9061','9062','9063','9064','9065','9066','9067','9068','9069','9070','9071'],
  "4":['9073','9074','9075','9076','9077','9078','9079','9080','9081','9072'],
  "5":['9277','9278','9279','9280','9281','9282','9283','9284','9285','9286','9287','9288','9289']
}


  var ii2
  var ii2a
    for (ii2 in h2list )
   {
    for (ii2a in h2list[ii2] )
    {
      h2all.push(h2list[ii2][ii2a])
    }
   }
   //console.log('THISVAL',in1,thisVal, state2)
   var stateNew={}
   //&&  thisVal.value !== state2['acat']
   if (thisVal.attr==='acust' && thisVal.value ==='charm'){
    stateNew["acat"]='-1'
    
  }
  if (thisVal.attr==='locket'){
    if (thisVal.value ==='no'){
      stateNew["m"]='no'  
    }
    else {
      if (state2["m"]==='no')
      stateNew["m"]='s'  
    
    }
  }
  if (thisVal.attr==='chain'){
    if (thisVal.value ==='no'){
      stateNew["m"]='no'  
    }
    else {
      if (state2["m"]==='no')
      stateNew["m"]='s'  
    
    }
  }
  if (state2['clist'] !=='-1' && state2['sku']==='9000'){
    stateNew["options_acust"]=  {...state2["options_acust"]}
   stateNew["options_acust"]['show']=true
   stateNew["options_acust"]['options'][1]['show']=true
   
  } 
  /*if (state2['m'] !=='-1' && state2['sku']==='9000'){
    stateNew["options_acust"]=  {...state2["options_acust"]}
    stateNew["options_acust"]['options'][0]['show']=true
  }*/ 
  if ((state2['m'] !=='-1' && state2['locket'] !=='no'  && state2['locket'] !=='-1' && state2['sku']!=='9000') ||((state2['locket'] ==='no'  ||state2['locket'] ==='no'  ) && state2['sku']!=='9000') ) {
    stateNew["options_acust"]=  {...state2["options_acust"]}
    stateNew["options_acust"]['show']=true
    stateNew["options_acust"]['options'][0]['show']=true
   
  } 
  if (thisVal.attr==='locket'){
    stateNew["options_acust"]=  {...state2["options_acust"]}
    stateNew["options_acust"]['show']=true
    stateNew["options_acust"]['options'][0]['show']=true
   
  } 
  

  if (thisVal.attr==='chain'){

    stateNew["options_acust"]=  {...state2["options_acust"]}
    stateNew["options_acust"]['show']=true
    stateNew["options_acust"]['options'][0]['show']=true
  
   
  } 
    
    if (thisVal.attr==='acust' && thisVal.value ==='locket'){
   // console.log('locket',thisVal, state2['m'])
    stateNew["options_m"]=  {...state2["options_m"]}
      
    if (state2['locket']==='no')
    {
      stateNew["options_m"]['show']=false
      stateNew["m"]='no'  
    }
    else{
     stateNew["options_m"]['show']=true
     if (state2["m"]==='no')
       stateNew["m"]='s'  
    } 
    stateNew["ai"]='-1'
  }
  if (thisVal.attr==='acust' && thisVal.value ==='chain'){
    // console.log('locket',thisVal, state2['m'])
     stateNew["options_m"]=  {...state2["options_m"]}
       
     if (state2['chain']==='no')
     {
       stateNew["options_m"]['show']=false
       stateNew["m"]='no'  
     }
     else{
      stateNew["options_m"]['show']=true
      if (state2["m"]==='no')
        stateNew["m"]='s'  
     } 
     stateNew["ai"]='-1'
   }
    

  if (thisVal.attr==='acat'){
    if (thisVal.value==='chain'){
      stateNew["options_m"]=  {...state2["options_m"]}
      stateNew["options_m"]['show']=true
      stateNew["options_am"]=  {...state2["options_am"]}
      stateNew["options_e"]=  {...state2["options_e"]}
      stateNew["options_f"]=  {...state2["options_f"]}
      stateNew["options_ai"]=  {...state2["options_ai"]}
      stateNew["options_am"]['show']=false
      stateNew["options_e"]['show']=false
      stateNew["options_f"]['show']=false
      stateNew["options_ai"]['show']=false
      stateNew["options_acharm"]=  {...state2["options_acharm"]}
      stateNew["options_acharm"]['show']=false

    }
    else  
    {
    stateNew["options_acharm"]=  {...state2["options_acharm"]}
    for (ii2 of stateNew["options_acharm"]['options'])
    {
      if (h2list[thisVal.value].includes(ii2.value))
      {
     // console.log('>>true',ii2)  
      //stateNew["options_acharm"]['options'][ii2]['show']=true
      ii2['show']=true
      }
    else 
      {
     //   console.log('>>false',ii2)  
        //stateNew["options_acharm"]['options'][ii2]['show']=false
        ii2['show']=false
        }
    }
  stateNew["options_acharm"]['show']=true
  stateNew['acat']=thisVal.value    
  //stateNew['acharm']='-1'
  stateNew["options_e"]=  {...state2["options_e"]}
  stateNew["options_f"]=  {...state2["options_f"]}
  stateNew["options_am"]=  {...state2["options_am"]}
  //stateNew["options_e"]['show']=false
  
  
  
  if (thisVal.value === '2' && state2['sku']==='9000'){
    stateNew['acharm']='4916'
    stateNew["options_e"]['show']=true
    stateNew["options_f"]['show']=false
    stateNew["options_am"]['show']=true
    stateNew['am']='s'
    
  }  
  else{
    if (state2['acharm']=='9329' || state2['acharm']=='9355')
      stateNew['acharm']=state2['acharm']
    else
      stateNew['acharm']='-1'
    stateNew["options_e"]['show']=false
    stateNew["options_f"]['show']=false
    stateNew["options_am"]['show']=false
  }
  
  stateNew['e1']=''
  stateNew['e2']=''
  stateNew["options_ai"]=  {...state2["options_ai"]}
  stateNew["options_ai"]['show']=false
  //stateNew["options_m"]=  {...state2["options_m"]}
  //stateNew["options_m"]['show']=false
}  
  }
  if (thisVal.attr==='acharm' ||thisVal.attr==='acat'){
    
    stateNew["options_am"]=  {...state2["options_am"]}
    stateNew["options_e"]=  {...state2["options_e"]}
    stateNew["options_ai"]=  {...state2["options_ai"]}
    stateNew["options_f"]=  {...state2["options_f"]}
    
    if (state2['style']==='9000') {
    
    stateNew["options_f"]['show']=false
    stateNew["options_e"]['show']=false
    stateNew["e1"]=''
    stateNew["e2"]=''
   // console.log('==',thisVal,state2['acharm'],stateNew['acharm'])
    if ((thisVal.attr==='acat' &&thisVal.value==='2')||(thisVal.attr==='acharm' && (thisVal.value==='4916' ||thisVal.value==='4917')))  {
      //state2['acharm']==='4916' ||state2['acharm']==='4917'||(
      stateNew["options_f"]['show']=false
      stateNew["options_e"]['show']=true
      stateNew["options_e"]['name']="Name"
      stateNew["options_e"]['options'][1]['show']=false
      stateNew["options_e"]['options'][0]['name']=''
      stateNew["options_e"]['options'][0]['maxLength']=8
      stateNew["options_e"]["filter"]="nameplate"
    //  console.log('==done',stateNew["options_e"]['name'])
    }
    if (thisVal.attr==='acharm' && thisVal.value==='6394') {
      stateNew["options_f"]['show']=true
      stateNew["options_e"]['show']=true
      stateNew["options_e"]['name']="Engraving"
      stateNew["options_e"]['options'][1]['show']=true
      stateNew["options_e"]['options'][0]['maxLength']=10
      stateNew["options_e"]['options'][0]['init_text']='Message'
      stateNew["options_e"]['options'][1]['maxLength']=10
      stateNew["options_e"]['options'][1]['init_text']='Here'
      stateNew["options_e"]['options'][0]['name']='Line 1'
      stateNew["options_e"]['options'][1]['name']='Line 2'
      stateNew["options_e"]["filter"]="charmengraving"
      
      
    }
    if (thisVal.attr==='acharm' && thisVal.value==='6395') {
      stateNew["options_f"]['show']=true
      stateNew["options_e"]['show']=true
      stateNew["options_e"]['name']="Engraving"
      stateNew["options_e"]['options'][1]['show']=true
      stateNew["options_e"]['options'][0]['maxLength']=10
      stateNew["options_e"]['options'][0]['init_text']='Message'
      stateNew["options_e"]['options'][1]['maxLength']=8
      stateNew["options_e"]['options'][1]['init_text']='Here'
      stateNew["options_e"]['options'][0]['name']='Line 1'
      stateNew["options_e"]['options'][1]['name']='Line 2'
      stateNew["options_e"]["filter"]="charmengraving"
      }
    if (thisVal.attr==='acharm' && thisVal.value==='6396') {
      stateNew["options_f"]['show']=true
      stateNew["options_e"]['show']=true
      stateNew["options_e"]['name']="Engraving"
      stateNew["options_e"]['options'][1]['show']=false
      stateNew["options_e"]['options'][0]['maxLength']=14
      stateNew["options_e"]['options'][0]['init_text']='Message'
      stateNew["options_e"]['options'][0]['name']='Line 1'
      stateNew["options_e"]['options'][1]['name']='Line 2'
      stateNew["options_e"]["filter"]="charmengraving"
      
    }
  //  console.log('ii2',state2['acharm'],stateNew)
 
  }
  
  
  
    if (state2['style']==='9082' && state2['acat'] ==='5') {
      stateNew["options_am"]['show']=false
    //  stateNew["am"]='s'
    }
    else
      stateNew["options_am"]['show']=true
    // if (state2['am']==='-1'){
    //  stateNew["am"]='s'
    //}
    stateNew["am"]='s'
    if (state2['acat']==='1'){
      stateNew["options_ai"]['show']=true
      if (state2['ai']==='-1'){
        stateNew["ai"]='a'
      }
      
    }
    else{
      stateNew["options_ai"]['show']=false
    }/*
    if (state2['acat']==='2'  ){
      stateNew["options_e"]['show']=true
      stateNew["options_f"]['show']=false
    }
    else if (state2['acat']==='11' && (state2['acharm']==='6394'||state2['acharm']==='6395'||state2['acharm']==='6396') ){
      stateNew["options_e"]['show']=true
      stateNew["options_f"]['show']=true
    }
    else {
      stateNew["options_e"]['show']=false
      stateNew["options_f"]['show']=false

    }*/
  

  }
 
    
  if (thisVal.attr==='delcharm'){
    //console.log('start del')
    newclist =state2['clist']
    var newclistlen=0
    var newclist2=''
    var thisValInt=parseInt(thisVal.value,10)
    if (state2['clist'] !=='-1') {
      newclist =newclist.split('_')
      newclistlen=newclist.length
    }
    if (thisValInt < newclistlen){
        
        for (var i=0;i<newclistlen;i++){
          if (thisValInt !== i)
          {
            if (newclist2 !=='')
              newclist2+='_'
            newclist2+=newclist[i]
          }
        }
      if (newclist2 ==='' )  {
        newclist2 ='-1'
        }
      stateNew['clist']=newclist2
     // console.log('new clist',state2['clist'],newclist2)
        
    } 
     else {
      stateNew['acat']='-1'
      stateNew["options_acharm"]=  {...state2["options_acharm"]}
      stateNew["options_acharm"]['show']=false
      stateNew["options_am"]=  {...state2["options_am"]}
      stateNew["options_e"]=  {...state2["options_e"]}
      stateNew["options_f"]=  {...state2["options_f"]}
      stateNew["options_ai"]=  {...state2["options_ai"]}
      stateNew["options_am"]['show']=false
      stateNew["options_e"]['show']=false
      stateNew["options_f"]['show']=false
      stateNew["options_ai"]['show']=false
      stateNew['acharm']='-1'
      stateNew['e']=''       
      stateNew['ai']='-1'
      stateNew['am']='s'

    }  
    
    
    
  
  
  
  } 
  //console.log('acat=1',thisVal,stateNew,state2)
  if (thisVal.attr==='acat' && thisVal.value==='1'){
    if (state2['acharm']!=='9329' && state2['acharm']!=='9355' && state2.s === '9000')
    stateNew["acharm"]=  '9329'
  }
      
  
    if (thisVal.attr==='add' && state2.am!=='-1'  && state2.acat!=='-1'  && state2.acharm!=='-1' && ((state2['acat'] !== '2') || (state2['acat'] === '2' && state2.s !== '9000') || (state2['acat'] === '2' && state2['e1'] !=='' && state2['e1'] !==undefined && state2.s === '9000'))){
      window.scrollTo({ top: 130, left: 0, behavior: 'smooth'})
      newclist =state2['clist']
    //    console.log('add',state2)
    if (state2['clist'] ==='-1')
     newclist =''
    else 
    newclist +='_'
    
    newclist += state2['acat'] +'|'+ state2['acharm'] +'|'+state2['am'] 
    if (state2['acat']==='1')
      newclist += '|'+state2['ai']
    if (state2['acat']==='2')
      newclist += '|'+state2['e1'] 
    if (state2['acat']==='11'){
      newclist += '|'+state2['f'] 
      newclist += '|'+state2['e1'] 
      newclist += '|' 
      newclist += state2['e2'] 
     }
//    console.log('newclist',newclist) 
    stateNew['clist']=newclist
    stateNew['acat']='-1'
    stateNew['acharm']='-1'
    stateNew['e1']=''
    stateNew['e2']=''
    stateNew['am']='s'
    stateNew['ai']='-1'
    stateNew["options_acharm"]=  {...state2["options_acharm"]}
    stateNew["options_am"]=  {...state2["options_am"]}
    stateNew["options_e"]=  {...state2["options_e"]}
    stateNew["options_f"]=  {...state2["options_f"]}
      
    stateNew["options_ai"]=  {...state2["options_ai"]}
    stateNew["options_am"]['show']=false
    stateNew["options_e"]['show']=false
    stateNew["options_f"]['show']=false

    stateNew["options_ai"]['show']=false
    stateNew["options_acharm"]['show']=false
  
      
  
}
 // console.log('accord newstate',stateNew,state2)
  return stateNew
  }

     
function controlLogic (state,action) {
  let newState={}
  var state2={...state}
  //var state2= Object.assign({}, state);
  //var state2= JSON.parse(JSON.stringify(state))
 // console.log('stat2state',state2,state,'m__1=',state2['m__1'])  
 
  // change to active view =1 if sc changed

  if (action.attr==='sc' ){
    newState['active_view']=1
  }
  let res_options={}



 
 
  var stateNew;

  



  //console.log('ACCORD2',state2['m__1'])  
  


 if (['9000','9082'].includes(state['sku']))
 {
  var ii2
  state2[action.attr] =action.value
  //console.log('state',state2,action)
  stateNew=refreshAccOption(state2,action,'all')
  for (ii2 in stateNew) 
  {
   if (stateNew[ii2].constructor === Object) 
    state2[ii2]={...stateNew[ii2] }
   else
    state2[ii2]=stateNew[ii2] 
   } 

  }


  //console.log('ACCORD4',state2['m__1'])  
  

  
  // main logic to update  available options based on style json 
  // with attribute effect_attr and effect_value in options with type 'control'
  // see template in admin-internal-template

  if (state2.hasOwnProperty('options_all') && state2['options_all'].indexOf(action.attr)!== -1) {
    //console.log('LOGIC start')   
    if (state2['options_'+action.attr].type ==='control') {
       let options = state2['options_'+action.attr].options
       //console.log('LOGIC show true in options1',options,action)
       for (let i in options ){
         if (options[i].value.toString() === action.value.toString()) {
          let option = options[i].effect
          //console.log('LOGIC show true in options2',option)
          for (let j in option) {
           if (option[j].hasOwnProperty('option')){
            // optionSet and options
            for (let l in option[j].optionSet) {
              if (!res_options.hasOwnProperty(option[j].optionSet[l])){
                res_options[option[j].optionSet[l]] = state2['options_'+ option[j].optionSet[l]]
              }  
              for (let k in option[j].option ) {
               // l is all optionSet, k is all options 
               for (let m in res_options[option[j].optionSet[l]].options ) {
                if  (res_options[option[j].optionSet[l]].options[m].attr ===option[j].option[k]) {
                  res_options[option[j].optionSet[l]].options[m][option[j].effect_attr] =option[j].effect_value
                  break  
                }
               }
              }
            }  
           } 
           else {
            // only optionSet 
            for (let l in option[j].optionSet) {
              if (!res_options.hasOwnProperty(option[j].optionSet[l])){
                res_options[option[j].optionSet[l]] = state2['options_'+ option[j].optionSet[l]]
              }  
                  res_options[option[j].optionSet[l]][option[j].effect_attr] = option[j].effect_value
            }  
           }
          }
        }
      }
    }  
  }
  for (let i in state2) {
    newState[i]=state2[i]
  }
  for (let i in res_options) {
    newState['options_'+i]=res_options[i]
  }
  newState[action.attr] =action.value 
  

  if (action.attr =="ga_event" && action.value == "Selected")
    {
      newState['altered'] = true
    }
  //console.log('NEW STATE',newState)
  return newState



}



export default function reducer(state = INITIAL_STATE, action) {
   //console.log('try start reducer',action,state)
    var newState
    var newState2
    switch (action.type) {
      case ACTIONS.START_OVER:
       // console.log('reducer start_over1',state.start_over_init,state);
        var json2 = JSON.parse(JSON.stringify(state.start_over_init));
        var json2a={}
        var initlist=['sc','bl'] //,'d','i']
     
        for (let op in initlist){
     //     console.log('try op',op);
        if (json2.hasOwnProperty(initlist[op]))
         json2a= controlLogic(json2,{'attr':initlist[op],'value':json2[initlist[op]]});
        }
        json2['showReview'] =false
        json2['clist']='-1'
        json2['acat']='-1'
        json2['chain']='-1'
        json2['acharm']='-1'
        json2['e']=''
        json2['am']='s'
        json2['ai']='-1'
        json2['realinit']='no'
       
        
   
        if (state.start_over_init.hasOwnProperty('sku') === false)
          json2['sku']=get_sku(state)
          //console.log('reducer start_over1',json2['sku']);
        
          if (json2['sku']==='9082' ||json2['sku']==='9000'){
            json2a['m']='-1'
            json2['locket']='-1'     
            json2['chain']='-1'     
            json2a['am']='-1'
        
            //console.log('reducer start_over2',json2a);
          
          }
            
     //   console.log('reducer start_over',json2,state);
  //      newState2.active_view ='1'
//        return  Object.assign({}, state, {...state.start_over_init, ...newState2});
        return  Object.assign({}, state, {...START_OVER_STATE,...json2,...json2a});
      case ACTIONS.LOAD_JSON:
        state.json='loaded'
  //      state.start_over_init = action.object
       // var newShowReview ={}
   //    console.log('reducer load_json',action);
        let options = action.object['options_all']
        // check all url parameters to match to available options
        for (let i in options ){
          let defaultValue = DEFAULT_STATE_VALUE
          if (options[i] ==='f') {
            defaultValue = '0'
          }
          if  (options[i] !=='e'  ) {
            if (state.hasOwnProperty(options[i]) !== DEFAULT_STATE_VALUE){
              let correctValue = false
              //console.log('opt',i,options[i],action)
              for (let j in action.object['options_'+options[i]].options) {
                 //console.log('in for',action.object['options_'+options[i]] , state[options[i]])
                 if  (action.object['options_'+options[i]].options[j].value === state[options[i]]){
                   correctValue =true
                   break
                 }
              }
              if (correctValue === false) {
                //console.log('orig val',options[i],state[options[i]])
                state[options[i]]=defaultValue
                //console.log('changed val to default',options[i])
              }
            }
          }
          else {
          // option e
          for (let j in action.object['options_'+options[i]].options) {
             let type = 'engraving'

             if (action.object['options_'+options[i]].options[j].hasOwnProperty('filter')){
                type=action.object['options_'+options[i]].options[j]['filter']
             }   
           //  console.log('in for',type,action.object['options_'+options[i]].options[j].maxLength ,options[i], state[action.object['options_'+options[i]].options[j]])
             state[action.object['options_'+options[i]].options[j].attr] =filter(state[action.object['options_'+options[i]].options[j].attr],
             type,action.object['options_'+options[i]].options[j].maxLength)
            // console.log('result filter',action.object['options_'+options[i]].options[j].attr,state[action.object['options_'+options[i]].options[j].attr])
          }
        }
      }
       // console.log('json.showReview',state,action)
        if (action.object['showReview'] === false)
         for (let i in options ){
           // need better test on init values fir show review
          if (options[i] !== 'e' && options[i] !== 'f' && state[options[i]] !== DEFAULT_STATE_VALUE) {
          // console.log('json.showReview found',options[i],state[options[i]] )
            action.object['showReview'] =true
           break
        }
        
       }
       //console.log('json.showReview1',state['m'],state['chain'],action.object['options_m']['show'],action)
        action.object['sku']=get_sku(action.object)
       action.object['active_view']=1
       if (((state['m'] !== '-1' && state['chain'] !== '-1') || state['chain'] === 'no' ) && state['clist'] === '-1')
       {
        if (state['chain'] !== 'no')
          action.object['options_m']['show'] =true
       action.object['options_acust']['options'][0]['show'] =true
       }
       //if (state['m'] !== '-1' && state['chain'] !== '-1' && state['clist'] !== '-1' && state['cat_s'] !=='')
       if (state['m'] !== '-1' && state['chain'] !== '-1' && state['clist'] !== '-1' )
         {
         action.object['options_acust']['options'][0]['show'] =true
         action.object['acust']='charm'
         action.object['options_m']['show'] =true
        }
      if ( action.object['cat_s'] !=='' && action.object['cat_s'] !=='-' ) 
        {
        action.object['acust']='charm'
        action.object['sku']='9000'
        action.object['am']='s'
        action.object['acat']=action.object['cat_s']
        action.object['options_acust']['options'][0]['show'] =true
          
        if ( action.object['cat_s'] ==='0' ) {
          action.object['acust']='chain'
          action.object['options_m']['show'] =true
          action.object['options_chain']['show'] =true
      //    console.log('json.showReview1',action)
         
        }
        else {
          action.object['options_acust']['options'][0]['show'] =true
          action.object['options_m']['show'] =false
          action.object['options_chain']['show'] =false
          action.object['options_acat']['show'] =true
          action.object['options_acharm']['show'] =true
          action.object['options_am']['show'] =true
        }
        if ( action.object['cat_s'] ==='1' ) {
            
          action.object['options_ai']['show'] =true
          action.object['ai'] ='a'
        }
        
        if ( action.object['cat_s'] ==='11' ) 
            action.object['options_e']['show'] =true
        if ( action.object['cat_s'] ==='2' ) {
            action.object['options_e']['show'] =true
            action.object['options_f']['show'] =true}

        if ( action.object['acharm']==='6394') {
          action.object["options_f"]['show']=true
          action.object["options_e"]['show']=true
          action.object["options_e"]['name']="Engraving"
          action.object["options_e"]['options'][1]['show']=true
          action.object["options_e"]['options'][0]['maxLength']=10
          action.object["options_e"]['options'][0]['init_text']='Message'
          action.object["options_e"]['options'][1]['maxLength']=10
          action.object["options_e"]['options'][1]['init_text']='Here'
          action.object["options_e"]['options'][0]['name']='Line 1'
          action.object["options_e"]['options'][1]['name']='Line 2'
          action.object["options_e"]["filter"]="engraving"
          
          
        }
        if (action.object['acharm']==='6395') {
          action.object["options_f"]['show']=true
          action.object["options_e"]['show']=true
          action.object["options_e"]['name']="Engraving"
          action.object["options_e"]['options'][1]['show']=true
          action.object["options_e"]['options'][0]['maxLength']=10
          action.object["options_e"]['options'][0]['init_text']='Message'
          action.object["options_e"]['options'][1]['maxLength']=8
          action.object["options_e"]['options'][1]['init_text']='Here'
          action.object["options_e"]['options'][0]['name']='Line 1'
          action.object["options_e"]['options'][1]['name']='Line 2'
          action.object["options_e"]["filter"]="engraving"
          }
        if (action.object['acharm']==='6396') {
          action.object["options_f"]['show']=true
          action.object["options_e"]['show']=true
          action.object["options_e"]['name']="Engraving"
          action.object["options_e"]['options'][1]['show']=false
          action.object["options_e"]['options'][0]['maxLength']=14
          action.object["options_e"]['options'][0]['init_text']='Message'
          action.object["options_e"]['options'][0]['name']='Line 1'
          action.object["options_e"]['options'][1]['name']='Line 2'
          action.object["options_e"]["filter"]="engraving"
          
        }
        var ii2
     //   if ( action.object['cat_s'] !=='' )
        if (action.object["cat_s"] !=='0' && action.object["cat_s"] !=='-')
        for (ii2 of action.object["options_acharm"]['options'])
        {
          //console.log('listt',action.object["cat_s"],CHARM_9000[action.object["cat_s"]],ii2)  
         
          if (CHARM_9000[action.object["cat_s"]].includes(ii2.value))
          {
         // console.log('>>true',ii2)  
          //stateNew["options_acharm"]['options'][ii2]['show']=true
          ii2['show']=true
          }
        else 
          {
        //    console.log('>>false',ii2)  
            //stateNew["options_acharm"]['options'][ii2]['show']=false
            ii2['show']=false
            }
        
         
          }   
          action.object['cat_s'] ='' 
       }
       
     //  console.log('json.showReview2',state,action)
       
        return  Object.assign({}, state, {...action.object});      
      case ACTIONS.FORCE_UPDATE: 
        newState={};
        newState2= controlLogic(state,action,newState2);
         // console.log('start reducer force',state,action,newState2)
          newState[action.attr]=action.value
          newState['sku']=get_sku(state)
         // console.log('newState2 force',newState2, {...newState, ...newState2})
          return  Object.assign({}, state, {...newState, ...newState2});
        
       //return state
      case ACTIONS.UPDATE:
        newState={};
        console.log('update',state,action)
      //console.log('update',state['vto_click'],window.vto_click)    
      newState2= controlLogic(state,action);
        if (state['vto_click'] === undefined)
          {
        //    console.log('update1')    
            if (window.vto_click  !== undefined){
             // console.log('update2',window.vto_click.toString())    
              if (window.vto_click.toString()  === '1')
              {
                newState['vto_click'] ='done'
           //     console.log('vto_click_state')    
                ReactGA.event({
                  category: 'VTO Click',
                  action: state.style
                });

              }
            }
            
          }   
          if (state['vto_used'] === undefined)
          {
        //    console.log('update1')    
            var VTOsku=['4039','4135', '4039','4135','7531','2618','5093','1692','2610','5165','2776','8255','3555','3887','2077','9873','1833','3171','1654','3116','7089','2797','4064','6053','6568','1931','9688','7318',
            '3889','1819','4197','9146','3172','1401','2900','2788','9755','7525','4188','4148','7685','6044','6604','4204','3949','9686','7623','7621','7350','7615','2962','3833','7118','2445','1105','8093','3566','5157',
            '4193','6274','7522','4232','2621','8590','4036','8716','2869','4139','8154','6743','2636','2959','1983','200','9874','6557','2104','9182','6279','3863','2400','3166','3110','1650','7500','2810','4918','7652',
            '1352','2080','2129','6605','1646','8682','1913','9857','7700','1932','9682','7061','8172','4192']
             // console.log('update2',window.vto_click.toString())    
              if (VTOsku.includes(state.style))
              {
                newState['vto_used'] ='done'
             //   console.log('vto_click_state')    
                ReactGA.event({
                  category: 'VTO used',
                  action: state.style
                });

              }
            
            
          }   
          if (state['vto_add_to_cart'] ===undefined)
          {
            if (window.vto_add_to_cart  !== undefined)
              if (window.vto_add_to_cart.toString()  === '1')
              {
                newState['vto_add_to_cart'] ='done'
                console.log('vto_add_state')    
                ReactGA.event({
                  category: 'VTO ADD',
                  action: state.style
                });

              }
            
          }   
         
         /*   if (window.vto_add_to_cart  !== undefined)
            allparam['vto'] +='-'+ window.vto_add_to_cart
         else
            allparam['vto'] += '-?'*/
         
          
        //if (state[action.attr] !==action.value)
        {
          newState[action.attr]=action.value
          let resObj = Object.assign({}, state, {...newState2, ...newState}); 
          if (['9000','9082'].includes(state.sku)!== true){
          resObj['sku']=get_sku(resObj)
        //  console.log('new sku',get_sku(resObj),resObj)
          }
          //console.log('newState2',newState2, {...newState, ...newState2})
          return resObj  
        }
    //   return state
      default:
       // console.log('default reducer with no logic',state,action)
        return state
    }
    
  }


// WEBPACK FOOTER //
// ./src/reducers/reducer.js